import Link from "next/link";
import { MissionListItem } from "./MissionListItem";
import { MissionModel } from "@api/models";

const dummyMission: MissionModel = {
  title: "ミッションのサンプルです",
};

export function MissionListDummyContent() {
  return (
    <div className="mission-list mode-dummy">
      <div className="mission-list-items">
        {[1, 2, 3].map((i) => {
          return <MissionListItem mission={dummyMission} key={i} />;
        })}
      </div>
      <div className="mission-list-dummy-content">
        <div className="mission-list-dummy-text">
          その他のミッションに参加するには
          <br />
          会員登録が必要です
        </div>
        <Link className="mission-list-dummy-button" href="/auth/signup?from=/gacha">
          無料会員登録する
        </Link>
      </div>
    </div>
  );
}
